/**
 * @generated SignedSource<<900ab519948fb1fbf55b37ae9b65905b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductStatus = "PUBLISHED" | "UN_PUBLISHED";
export type SetStatusProductInput = {
  productID: string;
  status: ProductStatus;
};
export type customizerTestProductSetStatusMutation$variables = {
  input: SetStatusProductInput;
};
export type customizerTestProductSetStatusMutation$data = {
  readonly setStatusProduct: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly model: {
      readonly id: string;
      readonly statusID: number;
    } | null;
  };
};
export type customizerTestProductSetStatusMutation = {
  response: customizerTestProductSetStatusMutation$data;
  variables: customizerTestProductSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Model",
  "kind": "LinkedField",
  "name": "model",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusID",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "customizerTestProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customizerTestProductSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetStatusProductPayload",
        "kind": "LinkedField",
        "name": "setStatusProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e77c430f93766e6e895e0a269bd033f8",
    "id": null,
    "metadata": {},
    "name": "customizerTestProductSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation customizerTestProductSetStatusMutation(\n  $input: SetStatusProductInput!\n) {\n  setStatusProduct(input: $input) {\n    model {\n      id\n      statusID\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bace216a6443431c4a700c12b0ce3a52";

export default node;
